"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Export classes
var DOMParserImpl_1 = require("./DOMParserImpl");
exports.DOMParser = DOMParserImpl_1.DOMParserImpl;
//# sourceMappingURL=index.js.map